export default "__VITE_ASSET__DtujMTMs__"